import { ChangeDetectionStrategy, Component, ViewEncapsulation, signal } from '@angular/core';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'core-sidebar-wrapper',
  templateUrl: './sidebar-wrapper.component.html',
  styleUrls: ['./sidebar-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSidenavContainer, MatSidenav],
})
export class SidebarWrapperComponent {
  public readonly opened = signal(true);
  public readonly openedSidenav = signal(false);

  public onTransitionEnd(): void {
    this.openedSidenav.update((v) => !v);
  }
}
